/**
 * @generated SignedSource<<8ebd89f2d2fe2e8c5bdb5ccf84dccb8a>>
 * @relayHash b0fcea74a8ae19aa6b20b42be161dd3e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fc06c660797b6f4f7ebfac9cdfb8833d0c29f622a7895591d06dadc7dea25ab8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type recentQueryConfigRecentlyCreatedByMeQuery$variables = {
  after?: string | null | undefined;
  cql: string;
  cqlcontext: string;
  first?: number | null | undefined;
};
export type recentQueryConfigRecentlyCreatedByMeQuery$data = {
  readonly search: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly emoji: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly links: {
          readonly editui: string | null | undefined;
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly metadata: {
          readonly currentuser: {
            readonly favourited: {
              readonly favouritedDate: string | null | undefined;
              readonly isFavourite: boolean | null | undefined;
            } | null | undefined;
            readonly lastcontributed: {
              readonly status: string | null | undefined;
              readonly when: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
        };
        readonly space: {
          readonly alias: string | null | undefined;
          readonly id: string | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly status: string | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type recentQueryConfigRecentlyCreatedByMeQuery = {
  response: recentQueryConfigRecentlyCreatedByMeQuery$data;
  variables: recentQueryConfigRecentlyCreatedByMeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cql"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cqlcontext"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "status"
},
v6 = [
  {
    "alias": "search",
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "cql",
        "variableName": "cql"
      },
      {
        "kind": "Variable",
        "name": "cqlcontext",
        "variableName": "cqlcontext"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      }
    ],
    "concreteType": "ConfluenceSearchConnection",
    "kind": "LinkedField",
    "name": "confluence_search",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSearchResponse",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "kind": "ScalarField",
                "name": "subType"
              },
              {
                "kind": "ScalarField",
                "name": "title"
              },
              (v5/*: any*/),
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "alias"
                  }
                ]
              },
              {
                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "webui"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "editui"
                  }
                ]
              },
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                    "kind": "LinkedField",
                    "name": "currentuser",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isFavourite"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "favouritedDate"
                          }
                        ]
                      },
                      {
                        "concreteType": "ContributionStatusSummary",
                        "kind": "LinkedField",
                        "name": "lastcontributed",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "when"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "emoji",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "keys",
                    "value": [
                      "emoji-title-published",
                      "emoji-title-draft"
                    ]
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JsonContentProperty",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "value"
                      }
                    ]
                  }
                ],
                "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          },
          {
            "kind": "ScalarField",
            "name": "endCursor"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "recentQueryConfigRecentlyCreatedByMeQuery",
    "selections": (v6/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "recentQueryConfigRecentlyCreatedByMeQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "b0fcea74a8ae19aa6b20b42be161dd3e",
    "id": "fc06c660797b6f4f7ebfac9cdfb8833d0c29f622a7895591d06dadc7dea25ab8",
    "metadata": {},
    "name": "recentQueryConfigRecentlyCreatedByMeQuery",
    "operationKind": "query",
    "text": "query recentQueryConfigRecentlyCreatedByMeQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{url,content{id,type,subType,title,status,space{id,name,alias},links{webui,editui},metadata{currentuser{favourited{isFavourite,favouritedDate},lastcontributed{status,when}}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}}}},pageInfo{hasNextPage,endCursor}}}"
  }
};
})();

(node as any).hash = "8d6f55a785a0bac07fd806ea1896d868";

export default node;
